const statusPorSituacao = [
    {
        regra: 'GESCON-UFI-PAG-00',
        situacoes: [
            {
                id: 0,
                status: [-1, 0, 1, 2, 3, 4, 5]
            },
            {
                id: 1,
                status: [-1, 0, 1, 3, 4]
            },
            {
                id: 2,
                status: [-1, 2, 9]
            },
            {
                id: 3,
                status: [-1, 5]
            }
        ]
    }
]

export default statusPorSituacao
